import { render, staticRenderFns } from "./RequestAdditionalInformation.vue?vue&type=template&id=0945c5d3"
import script from "./RequestAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./RequestAdditionalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports